import { create } from 'zustand'

interface ModalShareFileState {
  modalShareFile: {
    isOpen: boolean
    linksToShare: string[]
    propertyId: string
  }
  setModalShareFile: (modalShareFile: {
    isOpen: boolean
    linksToShare: string[]
    propertyId: string
  }) => void
  reset: () => void
}

const initialState = {
  modalShareFile: {
    isOpen: false,
    linksToShare: [],
    propertyId: ''
  }
}

export const useModalShareFileStore = create<ModalShareFileState>()((set) => ({
  ...initialState,
  setModalShareFile: (modalShareFile) => set({ modalShareFile }),
  reset: () =>
    set({
      modalShareFile: initialState.modalShareFile
    })
}))
